import { computed, ref, Ref } from 'vue';
import { ModalCustomProductStates } from '@/models/modal/modal.enum';
import store from '@/store';

export default class CustomProductsCode {
	public selectedCustomProductPrice: Ref<number | null> = ref(null);
	public selectedCustomProductDate: Ref<Date | null> = ref(null);
	public selectedCustomProductName: Ref<string> = ref('');
	public selectedCustomProductDescription: Ref<string> = ref('');

	public customProductModalActive = computed((): boolean => {
		return store.getters.modalCustomProductState() !== ModalCustomProductStates.INACTIVE;
	});

	public mounted(): void {
		store.mutations.incrementLoadCount();
	}

	public resetSelectedValues(): void {
		store.mutations.setSelectedTypeForCustomProductCreation(null);
		this.selectedCustomProductPrice.value = null;
		this.selectedCustomProductDate.value = null;
		this.selectedCustomProductName.value = '';
		this.selectedCustomProductDescription.value = '';
	}
}
